<script setup lang="ts">
import DedicatedTeamContent from './Components/DedicatedTeamContent.vue';

</script>

<template>
    <DedicatedTeamContent />
</template>
